module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_dehoyos_sm-dc7e8453ac0de9a8e92aa7744a83f1c9.png";